import { Component} from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
 selector: 'formly-dummy',
 template: '&nbsp;',
})
export class FormlyFieldDummyComponent extends FieldType {

}
